/** For a request our WAF refused (Cognito or the API), where Cognito's own copy would only say "Something went wrong". */
export const NETWORK_RATE_LIMIT_COPY = "Too many attempts from your network. Wait a few minutes and try again.";

/**
 * The API's WAF rate rules answer 429 {"error":"rate_limited","message":...} (FA #404).
 * Takes an axios error, a normalized Error carrying `status`, or a response body that a
 * slice passed to rejectWithValue.
 */
export const isRateLimited = (errorOrBody) =>
  errorOrBody?.status === 429 ||
  errorOrBody?.response?.status === 429 ||
  errorOrBody?.error === "rate_limited";

/** The server's own words when it sent some, else ours. */
export const rateLimitMessage = (body) =>
  (typeof body?.message === "string" && body.message.trim()) || NETWORK_RATE_LIMIT_COPY;

/**
 * 503 {"error":"jobs_unavailable","message":...,"retryAfterSeconds":30} from /handleSwipe and job
 * details while the job DB is out. Nothing was written and no swipe was spent.
 */
export const isJobsUnavailable = (errorOrBody) =>
  errorOrBody?.error === "jobs_unavailable" || errorOrBody?.response?.data?.error === "jobs_unavailable";

/** The server's own words for an outage, else `fallback`. */
export const jobsUnavailableMessage = (body, fallback = "Jobs are temporarily unavailable. Try again in a minute.") =>
  (typeof body?.message === "string" && body.message.trim()) || fallback;

/** The body's `retryAfterSeconds` in ms, or 0 when it sent none (or nonsense). */
export const retryAfterMs = (body) => {
  const seconds = Number(body?.retryAfterSeconds);
  return Number.isFinite(seconds) && seconds > 0 ? Math.min(seconds, 3600) * 1000 : 0;
};
